import axios, { AxiosInstance } from 'axios';
import { IError } from 'type/db';

import { getCookie } from 'utils/cookies';

export const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});

//cookied에서 token 가져와서 헤더에 Authorization로 추가해줘
const apiInterseptors = (axios_instance_arr: AxiosInstance[]) =>
	axios_instance_arr.forEach((item) => {
		item.interceptors.request.use(
			function (config) {
				const token = getCookie('Authorization');

				if (token && !config.url?.includes('login')) {
					if (!config.headers) {
						config.headers = {};
					}

					config.headers.Authorization = `Token ${token}`;
				}

				//url에 login이 있면 headers에 token 삭제
				if (config.url?.includes('login')) {
					if (!config.headers) {
						config.headers = {};
					}
					delete config.headers.Authorization;
				}
				return config;
			},
			function (error) {
				return Promise.reject(error);
			},
		);
		// 에러 응답 내에서 데이터만 반환
		item.interceptors.response.use(
			function (response) {
				return response;
			},
			function (error: IError) {
				if (error.response?.status === 401) {
					window.location.replace('/login');
				}
				console.log(error);
				return Promise.reject(error.response.data);
			},
		);
	});

apiInterseptors([api]);
